import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material"

const UserRoles = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>8. User Roles & Access Control</Typography>
        <Typography sx={{ fontSize: '1.1rem' }}>
        
        <List>
            <ListItem>
                <ListItemText>
                   <b>• Role-Based Access: </b> User roles (e.g., Sales Rep, Admin) determine access 
privileges within the app.
                </ListItemText>
            </ListItem>
             <ListItem>
                <ListItemText>
                    <b>• Admin Access: </b> Admins can assign tasks, view performance, and manage 
reports but cannot deactivate users via mobile.
                </ListItemText>
            </ListItem>
            <ListItem>
                <ListItemText>
                <b>• Account Deletion: </b> Admins can deactivate or delete accounts only through the 
web panel. Data remains secure unless explicitly deleted.
                </ListItemText>
            </ListItem>
        </List>
        </Typography>
        <Divider sx={{ my: 2 }} />
    </>
  )
}

export default UserRoles